import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

import {
    CookieService,
    PlatformUserDto,
    UserDTO,
    LinkUtil,
    AuthenticationService,
    SelectUserDTO,
    CookieUtil,
    PlatformValidityEnum
} from 'psd-common';
import { environment } from '../../../../environments/environment';
import { PublicUtil } from '@app/modules/central-login/util/public-util';

@Component({
    selector: 'central-login-dashboard',
    templateUrl: 'central-login-dashboard.component.html'
})
export class CentralLoginDashboardComponent implements OnInit {
    public currentUser: UserDTO;
    public platformUsers: Array<PlatformUserDto>;
    public busy: Subscription;
    public PlatformValidityEnum: typeof PlatformValidityEnum = PlatformValidityEnum;

    constructor(
        @Inject(DOCUMENT) private document: Document,
        private router: Router,
        private cookieService: CookieService,
        private authenticationService: AuthenticationService
    ) {}

    ngOnInit() {
        this.currentUser = PublicUtil.getCentralUser();

        let centralAccessTokenCookie = this.cookieService.getCentralCookie('central_access_token', environment.production);
        //  todo: move busy directive to psd-common library
        this.busy = this.authenticationService.loadCurrentPossibleUsers(centralAccessTokenCookie).subscribe(
            _result => {
                this.platformUsers = _result;
            },
            error => {
            }
        );
    }

    getProfilePictureLink(id: number, baseUrl: string): string {
        return LinkUtil.getMemberProfilePictureLink(id, null, baseUrl);
    }

    selectUser(platformUser: PlatformUserDto, hasAccessToPlatform: boolean) {
        if (!hasAccessToPlatform) {
            return;
        }

        let centralAccessToken = this.cookieService.getCentralCookie('central_access_token', environment.production);
        let centralRefreshToken = this.cookieService.getCentralCookie('central_refresh_token', environment.production);
        let selectUserDTO = new SelectUserDTO();
        selectUserDTO.userId = platformUser.platformUserId;
        selectUserDTO.platformId = platformUser.platformId;

        if (centralAccessToken && centralRefreshToken) {
            this.fillFormAndNavigateToPlatorm(selectUserDTO, platformUser, centralAccessToken, centralRefreshToken);
        } else {
            this.authenticationService.refreshCentralAccessToken(localStorage.getItem('userEmail'), centralRefreshToken, null).subscribe(_result => {
                CookieUtil.setCentralCookies( _result.access_token, _result.refresh_token, environment.production, _result.expires_in);
                this.fillFormAndNavigateToPlatorm(selectUserDTO, platformUser, centralAccessToken, centralRefreshToken);
            }, _error => {
            });
        }
    }

    fillFormAndNavigateToPlatorm(selectUserDTO: SelectUserDTO, platformUser: PlatformUserDto, centralAccessToken: string, centralRefreshToken: string) {
        this.authenticationService.selectUser(selectUserDTO, centralAccessToken, platformUser.apiURL).subscribe(_result => {
            // @ts-ignore
            let platformForm: HTMLFormElement = document.getElementById('goToPlatformForm');
            platformForm.action = platformUser.platformURL + '/index.php';
            platformForm['central_access_token'].value = centralAccessToken;
            platformForm['central_refresh_token'].value = centralRefreshToken;
            platformForm['access_token'].value = _result.access_token;
            platformForm['refresh_token'].value = _result.refresh_token;
            platformForm['expires_in'].value = _result.expires_in;
            platformForm['force_token_refresh'].value = 'true';
            platformForm.submit();
        });
    }

    goToAccountSettings() {
        this.router.navigate(['central-login/account-settings']);
    }

    goToHelpdocs() {
        window.open("https://help.prosoccerdata.com", '_blank');
    }
}
